module.exports = __webpack_public_path__ + "static/oranje-748cbfbb47fb4fd3bbd6ebb4c360db64.png";